import { ReactElement, useCallback } from 'react';
import { FieldError } from 'react-hook-form';
import { Info, Tooltip } from '@weareopenr/component-library';
import {
  StyledImgWrapper,
  StyledInfoTooltipLogoWrapper,
  StyledInput,
  HiddenInput,
  StyledInputWrapper,
  StyledLabel,
  StyledRadioButtonCard,
  StyledText,
} from './RadioButton.styles';

interface IRadioButtonProps {
  name: string;
  value: string;
  label: string;
  toolTipText: string;
  logo: ReactElement;
  isSelected?: boolean;
  error?: FieldError;
  hideRadio?: boolean;
}

const RadioButton = ({ name, value, label, toolTipText, logo, isSelected, error, hideRadio }: IRadioButtonProps) => {
  const tooltipRef = useCallback((node: HTMLSpanElement | null) => {
    if (node) {
      const button = node.querySelector('button');
      if (button) {
        button.type = 'button';
      }
    }
  }, []);

  return (
    <StyledLabel htmlFor={`${value}-option`}>
      <StyledRadioButtonCard is_selected={isSelected.toString()} error={error}>
        <StyledInfoTooltipLogoWrapper>
          <span ref={tooltipRef}>
            <Tooltip text={toolTipText} position="top" hasArrow={true}>
              <Info />
            </Tooltip>
          </span>
        </StyledInfoTooltipLogoWrapper>
        <StyledImgWrapper>{logo}</StyledImgWrapper>
        <StyledInputWrapper>
          <StyledText is_selected={isSelected.toString()} data-testid={`p-${value}`}>
            {label}
          </StyledText>
          {hideRadio ? (
            <>
              <HiddenInput name={name} value={value} id={`${value}-option`} checked={isSelected} aria-label={value} />
            </>
          ) : (
            <>
              <StyledInput name={name} value={value} id={`${value}-option`} checked={isSelected} aria-label={value} />
            </>
          )}
        </StyledInputWrapper>
      </StyledRadioButtonCard>
    </StyledLabel>
  );
};

export default RadioButton;
